import { AnchorScrollTo } from '@studiometa/ui';
import { addClass, removeClass } from '@studiometa/js-toolkit/utils';

/**
 * TableOfContentAnchor class.
 */
export default class TableOfContentAnchor extends AnchorScrollTo {
  /**
   * Config.
   */
  static config = {
    name: 'TableOfContentAnchor',
    options: {
      activeClass: {
        type: String,
        default: 'is-active',
      },
    },
  };

  offset = 0;

  sentinelDimensions = {
    top: 0,
    height: 0,
  };

  /**
   * Get the sentinel.
   * @returns {HTMLElement}
   */
  get sentinel() {
    return document.querySelector(this.targetSelector);
  }

  /**
   * Init observer on mount.
   * @returns {void}
   */
  mounted() {
    if (!this.sentinel) return;

    this.setDimensions();
  }

  /**
   * Resized
   */
  resized() {
    if (!this.sentinel) return;

    this.setDimensions();
  }

  /**
   * Set dimensions
   */
  setDimensions() {
    const dimensions = this.sentinel.getBoundingClientRect();

    this.sentinelDimensions = {
      height: dimensions.height,
      top: dimensions.top + window.scrollY,
    };

    this.offset = Number.parseInt(window.getComputedStyle(this.sentinel).scrollMarginTop, 10) + 1;
  }

  /**
   * Scrolled
   */
  scrolled() {
    if (!this.sentinel) return;

    const isVisible =
      window.scrollY + this.offset >= this.sentinelDimensions.top &&
      window.scrollY + this.offset < this.sentinelDimensions.top + this.sentinelDimensions.height;

    if (isVisible) {
      addClass(this.$el, this.$options.activeClass);
    } else {
      removeClass(this.$el, this.$options.activeClass);
    }
  }
}
